import networkActions from '../modules/network'

// pluck an error message from the response body if present
const getErrorMessage = (error) => {
  const res = error.response
  return res && res.data ?
    res.data.error || res.data :
    error.toString()
}

const networkWrapper = ({

  // the prefix and name so we can set loading and error status
  // in the network reducer - this means containers can
  // ask "is this method loading" or "was there an error with this method"
  // to display loading spinners, error messages and disable buttons
  prefix,
  name,

  // the handler function for this method - is passed dispatch, getState
  handler,

  // a function to handle any errors that were caught - normally a snackbar messaage
  errorHandler,

  // function to run once the loading status has been set to false
  after,

  globalLoading = false,
}) => async (dispatch, getState) => {
  const networkName = 
    [prefix, name]
    .filter(s => s)
    .join('/')

  dispatch(networkActions.clearError(networkName))
  dispatch(networkActions.startLoading(networkName))

  if(globalLoading) {
    dispatch(networkActions.setGlobalLoading(true))
  }

  let result = null

  try {
    result = await handler(dispatch, getState)
  } catch(error) {
    const errorMessage = getErrorMessage(error)
    console.error(error)
    console.error(errorMessage)
    dispatch(networkActions.setError({
      name: networkName,
      value: errorMessage,
    }))
    if(errorHandler) await errorHandler(dispatch, getState, errorMessage)
    result = null
  }

  dispatch(networkActions.stopLoading(networkName))

  if(after) {
    await after(dispatch, getState)
  }

  if(globalLoading) {
    dispatch(networkActions.setGlobalLoading(false))
  }

  return result
}

export default networkWrapper